
import {mapGetters, mapMutations} from 'vuex'
import Picker from 'vux/src/components/picker/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Group from 'vux/src/components/group/index.vue'

import vSelect from 'vue-select'
import {editUserInfo, getIndustryList} from '@/api/user'

export default {
computed: {
...mapGetters([
'profile'
])
},
components: {
vSelect,
Picker,
XButton,
Selector,
Group
},
data () {
return {
industryList: [],
industryIndex: '',
taxonomiesList: [
{
name: '软文营销',
active: false
},
{
name: '微信公众号',
active: false
},
{
name: '微博',
active: false
},
{
name: '短视频',
active: false
},
{
name: '视频直播',
active: false
},
{
name: '信息流',
active: false
}
]
}
},
methods: {
...mapMutations({
setProfile: 'SET_PROFILE'
}),
handleIndustrySelect (e) {
const idx = e.mp.detail.value
this.industryIndex = idx
this.profile.attribute.industry = this.industryList[idx]
},
handleTaxonomySelect (item, index) {
const taxonomies = this.profile.attribute.taxonomies
const idx = taxonomies.indexOf(item.name)
if (idx !== -1) {
taxonomies.splice(idx, 1)
this.taxonomiesList[index].active = false
} else {
this.profile.attribute.taxonomies.push(item.name)
this.taxonomiesList[index].active = true
}
this.profile.attribute.taxonomies = taxonomies
},
submitInfo () {
if (!this.profile.name || !this.profile.qq || !this.profile.company.name ||
!this.profile.attribute.industry || this.profile.attribute.taxonomies.length === 0) {
this.$vux.toast.show({
text: '请正确填写资料信息',
time: 1000
})
} else {
this.setProfile(this.profile)
let profile = this.profile
profile.scope = 'attribute'
editUserInfo(profile).then(res => {
console.log('第一次注册填写资料提交成功', res)
this.$router.push('/')
}).catch(err => console.log('修改资料错误', err))
}
}
},
mounted () {
getIndustryList().then(res => {
this.industryList = res.data.map(data => {
return data.name
})
})
}
}



// WEBPACK FOOTER //
// ./src/pages/registerProfile/index.vue